import { NgModule, APP_INITIALIZER } from '@angular/core';
import { filter } from 'rxjs/operators';
import { ServerTimeService } from './server-time.service';
import { AuthService } from '../auth/auth.service';
import { AuthModule } from '../auth/auth.module';

@NgModule({
  imports: [
    AuthModule,
  ],
  exports: [],
  declarations: [],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (authService: AuthService, serverTimeService: ServerTimeService) => () => {
        authService.isAuthenticated$
          .pipe(filter(Boolean))
          .subscribe(serverTimeService.init);
      },
      deps: [AuthService, ServerTimeService]
    },
    ServerTimeService,
  ],
})
export class ServerTimeModule { }
